import labelConfig from "./functions/label-config.json";
import {BASE_URL} from "./env";
import {FINTRO, isFintro} from "helpers/domain";

// let initEvent = new Event("init");
const labelsService = `${BASE_URL}/party/estx-resource-public/v1/labels/`;
// const fetchOptions = {
//   credentials: "include",
//   headers: {
//     Accept: "application/json",
//     "Content-Type": "application/json",
//   },
// };

const SUPPORTED_LANGUAGES = ["FR", "NL"];

// LANGUAGE`
export const getLangFromUrl = () =>
    SUPPORTED_LANGUAGES.includes(
        window.location.pathname.split("/")[1].toUpperCase()
    ) && window.location.pathname.split("/")[1].toUpperCase();


const language = () => {
    const langFromUrl = getLangFromUrl();
    localStorage.setItem("language", langFromUrl || "FR");
};

// LABLES
const fetchLabels = async () => {
    try {
        const lang = getLangFromUrl() || "FR";
        const response = await fetch(`${labelsService}${lang}`)
        return (
            response.ok === true && response.json()
        );
    } catch (e) {
        return "";
    }
};

const filterLabels = (arr, brand) =>
    arr.reduce((a, b) => {
        const i = a.findIndex((x) => x.internalKey === b.internalKey);
        if (i < 0) return [...a, b];

        if (i >= 0) {
            const HBInternalField = arr
                .filter((c) => c.internalKey === b.internalKey)
                .filter((d) => d.internalField === brand || d.internalField === "All");

            const accLabelArray = [...a];
            accLabelArray.splice(i, 1);

            return [...accLabelArray, ...HBInternalField];
        }
    }, []);

const recursiveLabelMapping = (obj, {lang, labels, translations, brand}) => {
    for (const k in obj) {
        if (typeof obj[k] === "object" && obj[k] !== null) {
            recursiveLabelMapping(obj[k], {lang, labels, translations, brand});
        } else {
            const id = obj[k].toString();
            const label = labels[lang];
            // label.findAll by internalKey === id
            // one entry -> take it
            // more than one -> take the brand
            const filterLabels = label.filter(item => item.internalKey === id);
            let text = filterLabels[0]?.rawText;
            if (filterLabels.length > 1) {
                text = filterLabels.find(item => item.internalField === brand)?.rawText
            }
            if (text !== undefined) {
                obj[k] = text;
                translations[lang.toLowerCase()] = {
                    ...translations[lang.toLowerCase()],
                    ...obj,
                };
            }
        }
    }
};

const mappingTraLabelId = (response, brand) => {
    const LANG = localStorage.getItem("language");
    const labels = {
        [LANG]: filterLabels(response, brand)
    }
    const translations = {default: {[LANG.toLowerCase()]: {}}};

    recursiveLabelMapping(
        {...labelConfig},
        {lang: LANG, labels, translations: translations.default, brand}
    );

    return translations;
};

export const getLabels = async (brand) => {
    const translations = await mappingTraLabelId(await fetchLabels(), brand);
    localStorage.setItem("translations", JSON.stringify(translations));
    return translations;
};


const initDOD = async () => {
    const init = async () => {
        language();
        await getLabels(isFintro() ? FINTRO : "All");
    };

    await init();
};

export default initDOD;
